var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooter1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 405,
    viewBox: "0 0 494 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.187 384.792C191.345 373.807 123.893 298.879 133.53 217.436C143.166 135.993 226.242 78.8764 319.084 89.8617C411.927 100.847 479.379 175.775 469.742 257.218C460.106 338.66 377.03 395.777 284.187 384.792Z",
    fill: "#F4B7EA",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.948 175.054L407.972 197.538C424.07 199.443 435.577 214.038 433.672 230.136L433.67 230.155C431.765 246.253 417.17 257.76 401.072 255.855L211.048 233.371C194.95 231.466 183.443 216.871 185.348 200.773L185.35 200.754C187.255 184.656 201.85 173.149 217.948 175.054Z",
    fill: "#F4B7EA",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.29 99.1698C197.307 65.2157 228.089 40.9474 262.043 44.9649C295.997 48.9824 320.266 79.7645 316.248 113.719L314.935 124.816C310.918 158.77 280.135 183.038 246.181 179.021C212.227 175.003 187.959 144.221 191.977 110.267L193.29 99.1698Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M243.923 147.207C228.631 145.398 218.319 126.318 220.89 104.591C223.461 82.8642 237.941 66.7178 253.233 68.5271C268.524 70.3365 278.836 89.4164 276.266 111.143C273.695 132.87 259.215 149.017 243.923 147.207Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M263.999 57.7978L249.757 87.6578L286.581 85.9947L263.999 57.7978Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M316.224 113.717C320.241 79.7626 351.024 55.4942 384.978 59.5118C418.932 63.5293 443.2 94.3113 439.182 128.265L437.869 139.363C433.852 173.317 403.07 197.585 369.116 193.568C335.162 189.55 310.893 158.768 314.911 124.814L316.224 113.717Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M366.893 161.757C351.601 159.948 341.289 140.868 343.86 119.141C346.43 97.414 360.911 81.2676 376.202 83.0769C391.494 84.8863 401.806 103.966 399.235 125.693C396.665 147.42 382.184 163.566 366.893 161.757Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M386.969 72.3489L372.727 102.209L409.533 100.544L386.969 72.3489Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M408.805 227.202L212.696 203.998",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M164.588 211.113L103.272 233.209L112.674 153.752C133.333 152.558 148.603 136.192 148.462 118.846C148.356 105.63 139.317 93.1015 125.703 87.3833C127.015 77.88 134.605 19.7576 117.047 9.80324C116.098 9.25967 114.373 8.30537 112.12 8.48884C97.7839 9.66201 91.5748 54.6883 90.526 62.76C72.3829 73.7601 54.2398 84.7603 36.0966 95.7605C35.5968 101.253 35.495 110.355 38.8861 120.846C43.2576 134.304 51.1273 142.925 55.356 146.97C48.7034 188.136 44.8902 223.375 42.6034 250.786C40.0379 281.503 40.274 291.395 46.6388 298.469C69.5984 323.953 147.611 285.491 159.377 279.569",
    fill: "#F4B7EA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M164.588 211.113L103.272 233.209L112.674 153.752C133.333 152.558 148.603 136.192 148.462 118.846C148.356 105.63 139.317 93.1015 125.703 87.3833C127.015 77.88 134.605 19.7576 117.047 9.80324C116.098 9.25967 114.373 8.30537 112.12 8.48884C97.7839 9.66202 91.5748 54.6883 90.526 62.76C72.3829 73.7601 54.2398 84.7603 36.0966 95.7605C35.5968 101.253 35.495 110.355 38.8861 120.846C43.2576 134.304 51.1273 142.925 55.356 146.97C48.7034 188.136 44.8902 223.375 42.6034 250.786C40.0379 281.503 40.274 291.395 46.6388 298.469C69.5984 323.953 147.611 285.491 159.377 279.569",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.121 116.971C106.151 120.337 95.6524 116.656 92.5309 109.911C89.8429 104.097 93.3975 97.6726 93.8725 96.8286C98.7647 88.2928 111.47 84.4136 125.695 87.3532",
    fill: "#F4B7EA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.121 116.971C106.151 120.337 95.6524 116.656 92.5309 109.911C89.8429 104.097 93.3975 97.6726 93.8725 96.8286C98.7647 88.2928 111.47 84.4136 125.695 87.3532",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.843 114.131C64.712 113.169 59.7215 98.858 61.6965 82.167C63.6714 65.4759 71.8638 52.7251 79.9948 53.6872C88.1258 54.6493 93.1163 68.9599 91.1414 85.651C89.1665 102.342 80.974 115.093 72.843 114.131Z",
    fill: "#F4B7EA",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.386 110.659C35.255 109.697 29.9637 97.9282 31.5676 84.3731C33.1715 70.818 41.0631 60.6094 49.1941 61.5715C57.3251 62.5336 62.6164 74.302 61.0125 87.8571C59.4086 101.412 51.517 111.621 43.386 110.659Z",
    fill: "#F4B7EA",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M285.384 288.1C270.846 264.831 248.638 253.445 234.872 258.83C213.653 267.141 208.9 316.822 229.727 329.264C242.497 336.888 265.104 330.636 282.494 312.533L285.384 288.1Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M305.537 290.486C325.105 271.252 349.357 265.364 361.486 273.813C380.179 286.846 373.207 336.264 350.051 343.502C335.855 347.936 315.331 336.581 302.646 314.919L305.537 290.486Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M290.092 320.654C279.193 319.364 271.403 309.483 272.693 298.584C273.982 287.685 283.863 279.895 294.762 281.184C305.662 282.474 313.452 292.355 312.162 303.254C310.872 314.154 300.991 321.944 290.092 320.654Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter1);
export default __webpack_public_path__ + "static/media/footer1.b3a820063a0dc732a62352a0781f9728.svg";
export { ForwardRef as ReactComponent };